import { TFunction } from 'i18next';

import { translations } from 'locales/i18n';

export type ElectionStatus = 'active' | 'future' | 'finished';

export function getStatusLabel(
  status: ElectionStatus,
  t: TFunction<'translation', undefined>
): string {
  switch (status) {
    case 'future':
      return t(translations.pages.polyas.status.planned());
    case 'active':
      return t(translations.pages.polyas.status.active());
    case 'finished':
      return t(translations.pages.polyas.status.finished());
  }
}
